import { Box, Card, Link, Typography, styled } from '@mui/material';
import configMapper from 'src/config/config.mapper';
import { useTranslation } from "react-i18next";

const FooterWrapper = styled(Card)(({ theme }) => `
    border-radius: 0;
    position: relative;
    bottom: 0;
    width: 100%;
    z-index: 1000;
    margin-top: ${theme.spacing(4)};
  `
);

function Footer() {
  const { t }: { t: any } = useTranslation();

  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        p={4}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1">
          &copy;{` 2024 - ${configMapper.APP_DISPLAY_NAME} BO`}
          </Typography>
        </Box>
        <Typography sx={{ pt: { xs: 2, md: 0 } }} variant="subtitle1">
          {t("Crafted by")}{' '}
          <Link href="https://vortex-it.com/" target="_blank" rel="noopener noreferrer">
            Vortex-it
          </Link>
        </Typography>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
